import { FunctionComponent, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoadingSpinner } from "src/components/generic";
import SquareTile from "src/components/generic/tiles/SquareTile";
import { dynamo } from "src/utils";

interface IClientCreditApplicationTileProps {
    cid: string;
    clientEmail: string;
    leadAssigned: {
        id: string;
        name: string;
    }
}

const ClientCreditApplicationTile: FunctionComponent<IClientCreditApplicationTileProps> = ({ clientEmail, cid, leadAssigned }) => {
    const [applications, setApplications] = useState<Record<any, any>[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    const fetchApplications = async () => {
        try {
            const result = await dynamo.fetch.clientCreditApplications(clientEmail)
            setApplications(result.creditApps);
        } catch (error: any) {
            setError(error?.message || "Error Fetching Applications");
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if(!applications) fetchApplications()
    }, [])
    
    if(loading || !applications) return <LoadingSpinner />
    return (
        <SquareTile title="Credit Applications">
            {error && <p>{error}</p>}
            {
                applications.map(application => {
                    const { applicationId, applicationFormData, metadata } = application;
                    return (
                        <div key={applicationId}>
                            <p>Consent: {applicationFormData.consent || "False"}</p>
                            <p>Submission Date: {metadata.applicationSubmit}</p>
                            <p>Lead: {leadAssigned.name}</p>
                            <Link to={`/dashboard/consultant/clients/${cid}/apps/${applicationId}`}>
                                View Application
                            </Link>
                        </div>
                    )
                })
            }
        </SquareTile>
    )
}

export default ClientCreditApplicationTile;